import { BarLineComboChartSeries } from 'types/e-charts';
import { LeadAnalyticsLocation } from 'types/lead-management';

export enum LeadSummaryTab {
  COUNT = 'count',
  REVENUE = 'revenue'
}

export interface LeadSource {
  label: string;
  value: number;
  color: string;
  count: number;
}

export interface LeadStatusSummaryRow {
  id: string;
  label: string;
  count: Record<string, number>;
  revenue: Record<string, number>;
  totalCount: number;
  totalRevenue: number;
}

export interface LeadAnalyticsLoading {
  statusChart: boolean;
  sources: boolean;
  locations: boolean;
  agents: boolean;
}

export interface LeadAnalyticsData {
  statusSeries: BarLineComboChartSeries[];
  sourceItems: LeadSource[];
  locations: LeadAnalyticsLocation[];
  agentRows: LeadStatusSummaryRow[];
  agentStatusList: { id: string; name: string; color: string }[];
  isSalesAgent: boolean;
  loading: LeadAnalyticsLoading;
}
